import React from 'react';
import { FadeIn, Section, SectionLabel } from './UI';
export const ProblemSection = () => {
  return <>
      <Section className="bg-brand-grayBg" data-id="element-91">
        <FadeIn data-id="element-92">
          <SectionLabel data-id="element-93">¿Te suena familiar?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-94">
            Llevas semanas buscando.
            <br data-id="element-95" />
            <span className="text-brand-purple" data-id="element-96">
              Y aún no has dado el primer paso.
            </span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-97">
            Has visto videos. Has leído artículos. Has preguntado en grupos. Y
            aun así…
          </p>

          <ul className="my-[30px]" data-id="element-98">
            {['No sabes exactamente por qué pasos empezar ni en qué orden', 'No estás seguro de qué tipo de empresa registrar para tu situación', 'Tienes miedo de cometer un error que te cueste caro — tiempo o dinero', 'Cada respuesta que encuentras genera tres preguntas nuevas', 'Sientes que el proceso es más complicado de lo que debería ser'].map((item, i) => <li key={i} className="py-[14px] border-b border-brand-border text-[1.05rem] flex items-start gap-3" data-id="element-99">
                <span className="text-brand-pink font-bold text-[1.1rem] shrink-0 mt-[2px]" data-id="element-100">
                  ✗
                </span>
                {item}
              </li>)}
          </ul>

          <div className="bg-brand-purple text-brand-white rounded-2xl py-8 px-9 mt-[30px] text-[1.2rem] italic leading-[1.6] text-center" data-id="element-101">
            <strong className="text-brand-pink font-bold" data-id="element-102">
              El problema no es que falte información.
            </strong>
            <br data-id="element-103" />
            El problema es que hay demasiada — y ninguna te la da en orden, con
            los errores reales, para tu situación específica.
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-104">
        <FadeIn data-id="element-105">
          <SectionLabel data-id="element-106">Por qué los métodos comunes no funcionan</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-107">
            No es tu culpa que
            <br data-id="element-108" />
            <span className="text-brand-purple" data-id="element-109">sigas paralizado.</span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-110">
            Los métodos que la mayoría usa están diseñados para informar — no
            para que ejecutes.
          </p>

          <div className="overflow-x-auto mt-8" data-id="element-111">
            <table className="w-full border-collapse text-[0.97rem]" data-id="element-112">
              <thead data-id="element-113">
                <tr className="bg-brand-purple text-brand-white" data-id="element-114">
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-115">
                    Método Común
                  </th>
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-116">
                    Por Qué Falla
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-117">
                <tr className="bg-brand-grayBg" data-id="element-118">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-119">
                    🔍 Buscar en Google
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-120">
                    Información fragmentada, desactualizada, sin orden y
                    genérica
                  </td>
                </tr>
                <tr data-id="element-121">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-122">
                    📺 Videos de YouTube
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-123">
                    Sin secuencia, no cubren tu caso, y evitan los errores
                    reales
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-124">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-125">
                    👥 Grupos de Facebook
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-126">
                    Opiniones contradictorias de personas que tampoco lo
                    hicieron bien
                  </td>
                </tr>
                <tr data-id="element-127">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-128">
                    💸 Contratar sin entender
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-129">
                    Gastas sin saber qué compraste ni si lo estás haciendo
                    correcto
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-130">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-131">
                    ✅ <strong data-id="element-132">Ruta USA 360</strong>
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-brand-purple font-semibold" data-id="element-133">
                    Proceso completo · En orden · Con los errores que debes
                    evitar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </FadeIn>
      </Section>
    </>;
};